import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { FirePilotGameCoreService } from './fire-pilot-game-core.service';
import { FirePilotGameSelectorComponent } from './fire-pilot-game-selector/fire-pilot-game-selector.component';

@NgModule({
  declarations: [FirePilotGameSelectorComponent],
  imports: [CommonModule, ReactiveFormsModule, SharedModule],
  providers: [FirePilotGameCoreService],
  exports: [FirePilotGameSelectorComponent],
})
export class FirePilotGameCoreModule {}
